import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiEyeOutline } from "@mdi/js";
import ConfirmationModal from "app/components/common/ConfirmationModal";
import { REASON_CODES } from "app/containers/Jobs/utils/contractReasons";

const RevokeContractModal = ({
  show,
  onHide,
  onConfirm,
  clientName,
  isLoading = false,
}) => {
  const [reasonCode, setReasonCode] = useState("");
  const [touched, setTouched] = useState(false);

  // Reopening must not inherit the last selection.
  useEffect(() => {
    if (show) {
      setReasonCode("");
      setTouched(false);
    }
  }, [show]);

  // reason_code is required by the backend, so the modal stays open and marks
  // the field instead of firing a request that is a guaranteed 400.
  const handleConfirm = () => {
    if (!reasonCode) {
      setTouched(true);
      return;
    }
    onConfirm({ reasonCode });
  };

  return (
    <ConfirmationModal
      show={show}
      onHide={onHide}
      onConfirm={handleConfirm}
      title="Revoke Contract"
      confirmLabel="Revoke Contract"
      isLoading={isLoading}
      loadingLabel="Working"
      staticWhileLoading
    >
      <p className="mt-3 mb-3">
        Revoking this contract will notify {clientName || "your client"} and
        unlock the job fields for editing.
      </p>

      <Form.Group controlId="contract-reason-code">
        <Form.Label>
          Reason <span className="text-danger">*</span>
        </Form.Label>
        <Form.Select
          value={reasonCode}
          onChange={(e) => setReasonCode(e.target.value)}
          isInvalid={touched && !reasonCode}
          disabled={isLoading}
        >
          <option value="">Select a reason</option>
          {REASON_CODES.map((reason) => (
            <option key={reason.value} value={reason.value}>
              {reason.label}
            </option>
          ))}
        </Form.Select>
        {touched && !reasonCode && (
          <div className="jd-reason-error">Choose a reason to continue.</div>
        )}
        <Form.Text className="jd-reason-hint">
          <Icon path={mdiEyeOutline} size={0.6} className="me-1" />
          Visible for client
        </Form.Text>
      </Form.Group>
    </ConfirmationModal>
  );
};

export default RevokeContractModal;
